import React from "react";

const AdminHeader = () => {
  return (
    <div className="fixed_width">
      <div className="admin_header bg-[#016435] py-2 px-[60px] justify-between items-center flex">
        <img src="../img/newlogo.jpg" alt="" className="w-[200px] admin_logo" />
        <div className="sidepart flex justify-evenly w-[200px]">
          <p className="text-white bg-black rounded px-2 font-semibold text-[14px]">
            master
          </p>
          <p className="text-white font-semibold text-[14px]">ms demo</p>
          <p className="text-white font-semibold text-[14px]">Irp 0</p>
        </div>
      </div>
    </div>
  );
};

export default AdminHeader;
